var exports = {
  "f": "DisplayTab.module__sectionContent___UlRvY1",
  "j": "DisplayTab.module__radioSection___UlRvY1",
};

module.exports = exports;
